const GlobalTypes = {
  GET_CLIENT_STATUS_REQUEST: 'GET_CLIENT_STATUS_REQUEST',
  GET_CLIENT_STATUS_SUCCESS: 'GET_CLIENT_STATUS_SUCCESS',
  GET_CLIENT_STATUS_ERROR: 'GET_CLIENT_STATUS_ERROR',

  GET_COUNTRY_REQUEST: 'GET_COUNTRY_REQUEST',
  GET_COUNTRY_SUCCESS: 'GET_COUNTRY_SUCCESS',
  GET_COUNTRY_ERROR: 'GET_COUNTRY_ERROR',

  GET_STATE_REQUEST: 'GET_STATE_REQUEST',
  GET_STATE_SUCCESS: 'GET_STATE_SUCCESS',
  GET_STATE_ERROR: 'GET_STATE_ERROR',

  GET_ADDRESS_REQUEST: 'GET_ADDRESS_REQUEST',
  GET_ADDRESS_SUCCESS: 'GET_ADDRESS_SUCCESS',
  GET_ADDRESS_ERROR: 'GET_ADDRESS_ERROR',

  GET_STATUS_REQUEST: 'GET_STATUS_REQUEST',
  GET_STATUS_SUCCESS: 'GET_STATUS_SUCCESS',
  GET_STATUS_ERROR: 'GET_STATUS_ERROR',

  GET_ALL_NOTIFICATIONS_REQUEST: 'GET_ALL_NOTIFICATIONS_REQUEST',
  GET_ALL_NOTIFICATIONS_SUCCESS: 'GET_ALL_NOTIFICATIONS_SUCCESS',
  GET_ALL_NOTIFICATIONS_ERROR: 'GET_ALL_NOTIFICATIONS_ERROR',

  READ_NOTIFICATION_REQUEST: 'READ_NOTIFICATION_REQUEST',
  READ_NOTIFICATION_SUCCESS: 'READ_NOTIFICATION_SUCCESS',
  READ_NOTIFICATION_ERROR: 'READ_NOTIFICATION_ERROR',

  READ_ALL_NOTIFICATIONS_REQUEST: 'READ_ALL_NOTIFICATIONS_REQUEST',
  READ_ALL_NOTIFICATIONS_SUCCESS: 'READ_ALL_NOTIFICATIONS_SUCCESS',
  READ_ALL_NOTIFICATIONS_ERROR: 'READ_ALL_NOTIFICATIONS_ERROR'
};

export default GlobalTypes;
